import { withStyles, withWidth } from '@material-ui/core';
import React, {  useLayoutEffect } from 'react';
import StyledToolTip from "../../../common/StyledToolTip"
import TerminalSelect from "./TerminalSelect"
import { groupBy, orderBy, sortBy } from 'lodash';
import { compose } from 'recompose';
import { withAppConfig } from '../../../../appConfigContext';

const styles = (theme) => ({
  terminalIconStyle: {
    borderLeft: `1px solid ${theme.headerBorderColor}`,
    padding: '9px 0px 9px 5px',
    fontSize: theme.headerTextFontSize,
    fontWeight: 'bold',
    color: theme.commonAppHeaderTabColor,
    width: '72px',
    textAlign: 'center'
  },
  headerIconStyles: {
    height: '32px',
    boxSizing: 'border-box',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      color: theme.commonAppHeaderTabColor
    }
  }
});

const getTerminalMenuData = (userData) => {
  const groupDataByRegion = groupBy(userData.userProfile.terminals, 'terminalRegion');
  const terminalData = orderBy(Object.keys(groupDataByRegion));
  let options = terminalData.map((region) => ({
    region: region,
    regionTerminals: sortBy(groupDataByRegion[region], 'terminalCode')
  }));
  let activeTerminalData = userData.userProfile.terminals.find(
    (terminal) => terminal.terminalCode === userData.userProfile.terminal.code
  );

  return { options, activeTerminalData };
};

const TerminalMenu = ({ classes, userData, currentTerminalId, onChange, configJSON , width}) => {
  const [terminalAnchorEl, setTerminalAnchorEl] = React.useState(null);

  const handleTerminalClick = (event) => {
    setTerminalAnchorEl(event.currentTarget);
  };

  const handleTerminalClose = () => {
    setTerminalAnchorEl(null);
  };

  const handleTerminalChange = (terminal) => {
    setTerminalAnchorEl(null);
    onChange(terminal);
  };

  const { options } = getTerminalMenuData(userData);

  const activeTerminalData = userData.userProfile.terminals.find(
    (terminal) => terminal.terminalId === currentTerminalId
  );

  useLayoutEffect(() =>{
    handleTerminalClose();
  },[width])

  const {terminalAccessLabel} = configJSON;
  return (
    <div>
      <div
        className={`${classes.terminalIconStyle} ${classes.headerIconStyles}`}
        onClick={handleTerminalClick}
        data-automationid="terminal-access">
        <StyledToolTip title={terminalAccessLabel.menuLabel}>
          <span>
            {activeTerminalData.terminalCode}
            <i className="icon-down-dir" onClick={handleTerminalClick} />
          </span>
        </StyledToolTip>
      </div>
      {terminalAnchorEl && (
        <TerminalSelect
          terminalAnchor={terminalAnchorEl}
          closeTerminalmenu={handleTerminalClose}
          terminalOptions={options}
          handleTerminalChange={handleTerminalChange}
          activeTerminal={activeTerminalData}
        />
      )}
    </div>
  );
};

export default compose(withAppConfig,withStyles(styles), withWidth())(TerminalMenu);
